import { useMutation, useQueryClient } from "@tanstack/react-query";
import { updateBettingMarketMapping } from "@/api/bettingMarkets";
import { BettingMarketsQueryKeys } from "@/tanstackQuery/queries/bettingMarkets";
import { UpdateBettingMarketMappingParams } from "@/types/ApiResponses/BettingMarket";

export const useUpdateBettingMarketMapping = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: UpdateBettingMarketMappingParams) => updateBettingMarketMapping(params),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: [BettingMarketsQueryKeys.BettingMarketMappings, variables.marketId],
      });
    },
  });
};
